import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesAnalystCoverageContentPageTextInfoCls: string;
			investorsResourcesAnalystCoveragePeopleListItemCompanyCls: string;
			investorsResourcesAnalystCoveragePeopleListItemFullnameCls: string;
			investorsResourcesAnalystCoverageMailLinkCls: string;
			investorsResourcesAnalystCoverageWebLinkCls: string;
		}
	},

	slug: string
}

class List extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors Resources Analyst Coverage List Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageContentPageTextInfoCls || '', 'investors_resources_analyst_coverage_list', { animCls: 'animate__flipInX', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoveragePeopleListItemCompanyCls + '1', 'investors_resources_analyst_coverage_list', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoveragePeopleListItemCompanyCls + '2', 'investors_resources_analyst_coverage_list', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoveragePeopleListItemCompanyCls + '3', 'investors_resources_analyst_coverage_list', { animCls: 'animate__fadeInRight25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoveragePeopleListItemFullnameCls + '1', 'investors_resources_analyst_coverage_list', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoveragePeopleListItemFullnameCls + '2', 'investors_resources_analyst_coverage_list', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoveragePeopleListItemFullnameCls + '3', 'investors_resources_analyst_coverage_list', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageMailLinkCls + '1', 'investors_resources_analyst_coverage_list', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageMailLinkCls + '2', 'investors_resources_analyst_coverage_list', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageMailLinkCls + '3', 'investors_resources_analyst_coverage_list', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageWebLinkCls + '1', 'investors_resources_analyst_coverage_list', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageWebLinkCls + '2', 'investors_resources_analyst_coverage_list', { animCls: 'animate__rotateIn', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesAnalystCoverageWebLinkCls + '3', 'investors_resources_analyst_coverage_list', { animCls: 'animate__rotateIn', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default List;